import { useState } from "react";
import Logo from "assets/img/LOGO.png";
import ContactSupportPopPup from "./ContactSupportPopPup";

interface InitSupportDisplayProps {
  onNewConversation: () => void;
  userRole?: string;
}

const InitSupportDisplay: React.FC<InitSupportDisplayProps> = ({
  onNewConversation,
  userRole,
}) => {
  const [showSendMessagePopup, setshowSendMessagePopup] =
    useState<boolean>(false);

  // Déterminer si l'utilisateur est un administrateur
  const isAdmin = userRole === "adminStartup" || userRole === "adminSchool";

  // Texte adapté selon le rôle
  const getActionText = () => {
    if (isAdmin) {
      return "Créer une nouvelle conversation";
    }
    return "Créer une nouvelle conversation";
  };

  return (
    <div className="flex items-center justify-center h-full relative">
      <div className="flex justify-center items-center relative">
        <div className="flex flex-col items-center space-y-6">
          <div className="flex justify-center flex-grow">
            <img src={Logo} alt="Logo" className="w-32 h-32 object-contain" />
          </div>
          <div className="text-center text-black text-lg font-semibold font-['Open Sans'] leading-none">
            Cliquez sur une conversation pour commencer la discussion
          </div>
          <div className="flex flex-col text-center text-black text-sm font-normal font-['Open Sans'] leading-normal space-y-2">
            <div>
              Sélectionnez une conversation existante dans la liste à gauche
            </div>
            <div>ou créez une nouvelle demande d'assistance.</div>
          </div>
          {userRole !== "adminStartup" && (
            <button
              className="bg-[#E3B505] text-[#131CC9] rounded-md px-4 py-2"
              onClick={(e) => {
                e.stopPropagation();
                onNewConversation();
              }}
            >
              {getActionText()}
            </button>
          )}
        </div>
      </div>
      {showSendMessagePopup && (
        <ContactSupportPopPup
          onClose={() => setshowSendMessagePopup(false)}
          onConversationCreated={(conversation) => {
            setshowSendMessagePopup(false);
            // La gestion de la nouvelle conversation sera faite par le composant parent
          }}
        />
      )}
    </div>
  );
};

export default InitSupportDisplay;
